<template>
  <section class="sub-footer text-center py-4">
    <div class="container py-md-5">
      <h2 class="heading-2 mb-4">
        <span class="text-brand">Thousands </span>of Happy Marriages
      </h2>
      <button
        v-if="isShow"
        type="button"
        class="btn btn-brand-1 mb-md-5 mb-3 px-5"
        v-on:click="ShowRegister()"
      >
        register free
      </button>
      <p class="font-medium text-secondary font-18">
        This website only meant for users with a banafide intent to enter in to
        matrimonial alliance &amp; is not meant for users interested in dating
        only and this website should not be used to post an obscene
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "SubFooter",
  components: {},
  data() {
    return {
      isShow: true,
    };
  },
  mounted() {
    if (localStorage.getItem("access_token")) {
      this.isShow = false;
    }
  },
  methods: {
    ShowRegister() {
      this.$emit("showRegister");
    },
  },
};
</script>
